import React from "react";
import { Divider } from "antd";
import Search from "antd/es/transfer/search";
export default function TitleComp({ name, type, totalData, button, setSearchInput }) {
  return (
    <div className="mb-3">
      <div className="pageHeader d-flex align-items-center justify-content-between">
        <h2 className="pageTitle">{name}</h2>
        {button}
      </div>

      <Divider orientation="center">
        Total {type} ({totalData})
      </Divider>
      <Search style={{maxWidth:200}} className="w-50" placeholder={"Search "+name} allowClear onChange={(e)=>setSearchInput(e.target.value)} />
    </div>
  );
}
